"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurFusionPhilosophy() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="240694" id="the-ivory-aesthetic" className="dark bg-background text-foreground w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[800px]">
        {}
        <div className="relative w-full h-[400px] lg:h-full order-2 lg:order-1">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/ivory_lens_detail_shot.png" alt="Artistic detail shot of wedding lace and rings in natural light" className="absolute inset-0 w-full h-full object-cover grayscale contrast-125" />
          {}
          <div className="absolute inset-0 bg-gradient-to-r from-background/40 to-transparent pointer-events-none" />
        </div>

        {}
        <div className="bg-background text-foreground flex flex-col justify-center p-8 md:p-16 lg:p-24 xl:p-32 order-1 lg:order-2">
          <div ref={contentRef} className={`max-w-2xl mx-auto transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light font-default mb-8 tracking-tight">
              The Ivory Aesthetic
            </h2>
            
            <div className="space-y-6 text-justify text-lg md:text-xl leading-relaxed font-sans font-light opacity-90 mb-12">
              <p>
                At Ivory Lens, we believe that the most profound stories are told through the gentle interplay of{" "}
                <strong className="font-normal text-primary">
                  Natural Light and Shadow
                </strong>
                . Our signature aesthetic is defined by a soft-toned, airy quality that preserves the authentic emotion of your wedding day.
              </p>
              <p>
                We meticulously chase the golden hour and the soft diffusion of morning light to create imagery that feels both contemporary and timeless. By focusing on the subtle textures of silk, the warmth of a glance, and the quiet moments in between, we curate a collection that breathes with life.
              </p>
              <p>
                Our approach is one of refined nostalgia—capturing your legacy with a sophisticated visual language that transcends fleeting trends. Every frame is a deliberate composition, designed to evoke the same love and wonder decades from now as it does today.
              </p>
            </div>

            <Button asChild size="sm" variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-md px-8 py-6 text-base uppercase tracking-widest transition-colors duration-500">
              <Link to="/StoryPage">Our Story</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}